export default __webpack_public_path__ + "static/media/warning.a7c5f663.svg";